hrd.dashboard.validate.validateConfig = function() {
	var globalCgf = hrd.dashboard.validate.globalConfig();
	var validCfg = hrd.dashboard.validate.isValidConfig();
	return $.extend({}, globalCgf, validCfg);
};

hrd.dashboard.validate.globalConfig =  function() {
	return {
		validateOnBlur: false,
		validateOnEvent: false,
		addSuggestions: false
	};
};

hrd.dashboard.validate.isValidConfig =  function() {
    return {
        ignore : [], // Names of inputs not to be validated even though node attribute containing the validation rules tells us to
        errorElementClass : 'field-error', // Class that will be put on elements which value is invalid
        borderColorOnError : '', // Border color of elements which value is invalid, empty string to not change border color
        errorMessageClass : 'form-error', // class name of div containing error messages when validation fails
        validationRuleAttribute : 'data-validation', // name of the attribute holding the validation rules
        validationErrorMsgAttribute : 'data-validation-error-msg', // define custom err msg inline with element
        errorMessagePosition : 'element', // Can be either "top" or "element" or "custom"
        errorMessageParentSelector: '.field-composite',
        dateFormat : 'dd/mm/yyyy',
        addValidClassOnAll : false, // whether or not to apply class="valid" even if the input wasn't validated
        decimalSeparator : '.',
		errorMessageCustom: function(form, errorTitle, errorMessages, conf){
			var messages = [];
			$.each(errorMessages, function(i, msg){
				var fields = form.find('*[current-error="' + msg + '"]');
				$.each(fields, function(j, f){
					var id = $(f).attr('id');
					var label = $('label[for="' + id + '"]').text();
					messages.push(xlate('common.validation.error.item.msg', {field: label, message: msg}));
				});
			});
			// preparing final nmessage //
			var finalMessage = errorTitle;
			finalMessage += "<p><ul>";
			$.each(messages, function(k, m){
				finalMessage += '<li>' + m + '</li>';
			})
			finalMessage += "</ul>";

			const usingChromaFlow = $('.chroma-flow').exists();

			if(usingChromaFlow) {
				// show message in dialog
				hrd.dashboard.msgBox({
					icon: 'error',
					type: 'CANCEL',
					title: xlate('common.validation.error.header.msg'),
					text: finalMessage,
				});
			} else {
				// show message in dialog
				var vBox = hrd.dashboard.validationBox({
					title: xlate('common.validation.error.header.msg'),
					text: finalMessage,
					modal: false,
					width: 600
				});
			}

			form.data('validationBox', vBox);
		}
    };
};

hrd.dashboard.validate.language = function(extraValidations) {
	let original = {
		errorTitle: xlate('common.validation.error.title.msg'),
		requiredFields: xlate('common.validation.required.msg'),
		badReceiptNumber: xlate('common.validation.badReceiptNumber.msg'),
		notUnique: xlate('common.validation.notUnique.msg'),
		badDate : xlate('common.validation.badDate.msg'),
		badEmail : xlate('common.validation.badEmail.msg'),
		badUrl : xlate('common.validation.badUrl.msg'),
		badCustomVal : xlate('common.validation.badCustomVal.msg'),
		badPhoneNumber : xlate('common.validation.badPhoneNumber.msg'),
        lengthBadStart : xlate('common.validation.lengthBadStart.msg'),
        lengthBadEnd : xlate('common.validation.lengthBadEnd.msg'),
        lengthTooLongStart : xlate('common.validation.lengthTooLongStart.msg'),
        lengthTooShortStart : xlate('common.validation.lengthTooShortStart.msg'),
        badExpr : xlate('common.validation.badExpr.msg'),
        badBeforeFullNowEmpty : xlate('common.validation.badBeforeFullNowEmpty.msg'),
	};
	return $.extend(original, extraValidations);
};
